
    import '/opt/buildhome/repo/components/attachments/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["attachments-demo-basic","attachments-demo-placeholder","attachments-demo-overflow","attachments-demo-with-sender","attachments-demo-files","attachments-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/attachments/index.en-US.md?type=demo')
};